import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => {
  return (
    <NFLTemplate
      {...props}
      team="Minnesota Vikings"
      teamShort="Vikings"
      teamId={teamIds['Minnesota Vikings']}
    />
  )
}
